const DELIMITER = ';';

function escapeCsvCell(value: string): string {
  if (
    value.includes(DELIMITER) ||
    value.includes('"') ||
    value.includes('\n')
  ) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

function triggerCsvDownload(fileName: string, lines: string[]): void {
  // BOM pro Excel reconhecer UTF-8 (acentuação) sem pedir encoding manual.
  const blob = new Blob(['﻿' + lines.join('\r\n')], {
    type: 'text/csv;charset=utf-8',
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function downloadCsv(
  fileName: string,
  headers: string[],
  rows: (string | number)[][],
): void {
  const lines = [headers, ...rows].map((row) =>
    row.map((cell) => escapeCsvCell(String(cell))).join(DELIMITER),
  );
  triggerCsvDownload(fileName, lines);
}
